let isSyncing = false;
let sqmPerBox = null;
let includeBreakage = false;
function MyInits() {
  const container = document.getElementById("tile-calculator");
  if (!container) return;
  const sqmEl = container.querySelector("#sqm-per-box-data");
  const qtyInput = container.querySelector(".js-qty__num");
  const qtyPlus = container.querySelector(".js-qty__adjust--plus");
  const qtyMinus = container.querySelector(".js-qty__adjust--minus");
  const sqmInput = container.querySelector("#sqm-input");
  const breakageCheckbox = document.querySelector("[name='include-breakage']");
  const useCoverageBtn = document.querySelector("#use-coverage");
  const breakageCheckboxTop = document.getElementById("include-breakage-top");

  // 🔐 Guard clause: exit if core elements don't exist
  if (!sqmEl || !qtyInput || !qtyPlus || !qtyMinus || !sqmInput) return;

  let timeout = null;
  sqmPerBox = parseFloat(sqmEl.dataset.sqmPerBox);
  sqmPerBox = Number(sqmPerBox.toFixed(6)); // normalize precision  

  // Initialize raw sqm from the initial input value
  const initRaw = parseFloat(String(sqmInput.value || "0").replace(",", "."));
  if (!isNaN(initRaw)) setSqmInputRaw(sqmInput, initRaw);

  qtyPlus.addEventListener("click", () => {
    const qty = getQty(container);
    calcSQM(qty);
  });

  qtyMinus.addEventListener("click", () => {
    const qty = getQty(container);
    calcSQM(qty);
  });

  qtyInput.addEventListener("input", () => {
    const qty = getQty(container);
    calcSQM(qty);
  });

  sqmInput.addEventListener("input", function (event) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      sqmToBoxInput(event.target);
    }, 300);
  });

  sqmInput.addEventListener("focus", () => {
    // When editing, show RAW sqm so user can type normally
    const rawSqm = getRawSqmFromInput(sqmInput);
    sqmInput.value = rawSqm ? String(rawSqm) : sqmInput.value;
  });

  sqmInput.addEventListener("blur", () => {
    // When they leave the field, show SQM including wastage (if checked)
    renderSqmInput(sqmInput);
  });

  const addRowBtn = document.querySelector("#add-row-btn");
  if (addRowBtn) {
  addRowBtn.addEventListener("click", () => {
    const firstRow = document.querySelector(".sqm-calc .row");
    if (firstRow) {
      addRow(firstRow);
    }
  });
}


  // Optional handlers (safe checks)
  if (breakageCheckbox) {
    breakageCheckbox.addEventListener("change", (e) => {
      syncBreakageCheckboxes(e.target.checked, "bottom");
    });
  }

  if (breakageCheckboxTop) {
    breakageCheckboxTop.addEventListener("change", (e) => {
      syncBreakageCheckboxes(e.target.checked, "top");
    });
  }

  if (useCoverageBtn) {
    useCoverageBtn.addEventListener("click", addCoverageToOrder);
  }

  bindRowInputListeners();

}


function getQty(container) {
  const input = container.querySelector(".js-qty__num");
  let qty = input?.value || 1;
  if (parseFloat(qty) != parseInt(qty) || isNaN(qty)) qty = 1;
  return parseInt(qty);
}


function addCoverageToOrder() {
  const coverage = parseFloat(String(document.querySelector(".total-sqm").innerText || "0").replace(",", "."));
  const sqmInput = document.getElementById("sqm-input");

  if (coverage && coverage != 0) {
    const p = getBreakagePercent();

    // If breakage is enabled, the total-sqm is already "with breakage".
    // Store RAW = coverage / (1 + p/100) so rendering stays consistent.
    const raw = (includeBreakage && p > 0) ? (coverage / (1 + p / 100)) : coverage;
    setSqmInputRaw(sqmInput, raw);

    // show the correct display value in the field
    renderSqmInput(sqmInput);

    // coverage already represents the effective sqm to use for boxes
    calcBoxNum(coverage);

    document
      .querySelector(".product-single__vendor")
      .scrollIntoView({ behavior: "smooth" });
  }
}

function changeBreakage() {
  includeBreakage = !includeBreakage;
  calcTotalCoverage();
}

function addRow(rowClone) {
  const rowContainer = document.querySelector(".row-container");
  if (!rowClone || !rowContainer) return;

  const newRow = rowClone.cloneNode(true);

  // reset only the editable inputs in the new row
  newRow.querySelectorAll('.row-inputs .fsc-input-grid-item input').forEach(inp => {
    if (inp.name === 'sqm-result') {
      inp.value = 0;
    } else {
      inp.value = 0;
    }
  });

  rowContainer.appendChild(newRow);
  bindRowInputListeners();
}

function getActiveCurrency() {
  // Most common: Shopify global object
  if (window.Shopify?.country == 'IE') return "EUR";

  if (window.Shopify?.currency?.active) return window.Shopify.currency.active;

  // Some themes expose this
  if (window.theme?.currency?.active) return window.theme.currency.active;

  // Fallback: read from HTML lang/data attribute if you have it
  const htmlCurrency = document.documentElement.getAttribute("data-shopify-currency");
  if (htmlCurrency) return htmlCurrency;

  // Default
  return "GBP";
}

function formatMoney(amountNumber) {
  const currency = getActiveCurrency();

  // Use Intl if available (best output for symbols/spacing)
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amountNumber);
  } catch (e) {
    // Safe fallback (GBP/EUR only)
    const symbol = currency === "EUR" ? "€" : "£";
    return `${symbol}${amountNumber.toFixed(2)}`;
  }
}

let isSyncingBreakage = false;

function getBreakagePercent() {
  const el = document.querySelector("[data-breakage]");
  const p = parseFloat(el?.getAttribute("data-breakage") || "10");
  return isNaN(p) ? 10 : p;
}

function applyBreakageToSqm(sqm) {
  const p = getBreakagePercent();
  if (!includeBreakage || !p) return sqm;
  return sqm * (1 + p / 100);
}

function syncBreakageCheckboxes(checked, source) {
  if (isSyncingBreakage) return;
  isSyncingBreakage = true;

  includeBreakage = !!checked;

  const top = document.getElementById("include-breakage-top");
  const bottom = document.querySelector("[name='include-breakage']");

  if (top && source !== "top") top.checked = !!checked;
  if (bottom && source !== "bottom") bottom.checked = !!checked;

  // Recalculate bottom totals (so the calculator UI stays correct)
  calcTotalCoverage();

  // Apply wastage immediately to the current SQM → boxes/price
  const sqmInput = document.getElementById("sqm-input");
  if (sqmInput) {
    const rawSqm = getRawSqmFromInput(sqmInput); // ALWAYS raw
    const sqmForBoxes = checked ? applyBreakageToSqm(rawSqm) : rawSqm;

    // Update boxes/qty/price based on correct sqm
    calcBoxNum(sqmForBoxes);

    // Update what user sees in sqm input
    renderSqmInput(sqmInput);
  }

  // renderSqmInput(document.getElementById("sqm-input"));

  isSyncingBreakage = false;
}

function calcTotalCoverage() {;
  const rows = document.querySelectorAll(".sqm-calc .row");
  const totalCoverageEl = document.querySelector(".total-sqm");
  let totalCoverage = 0;

  rows.forEach((row) => {
    const inputs = getRowInputs(row);
    const rowResult = row.querySelector('input[name="sqm-result"]'); // <-- row-scoped result

    if (isRowFilled(inputs)) {
      const rowCoverage = calcRowCoverage(inputs);
      totalCoverage += rowCoverage;
      if (rowResult) updateDisplay(rowResult, rowCoverage);
    } else {
      if (rowResult) updateDisplay(rowResult, 0);
    }
  });

  if (includeBreakage) {
    const breakage = parseFloat(document.querySelector("[data-breakage]")?.getAttribute("data-breakage") || "0");
    totalCoverage = parseFloat((totalCoverage * (1 + breakage / 100)).toFixed(3));
  }

  updateDisplay(totalCoverageEl, totalCoverage);
}


function getRowInputs(row) {
  // Grab width/length inputs only (skip disabled SQM)
  const inputs = row.querySelectorAll('.row-inputs .fsc-input-grid-item input:not([disabled])');
  return Array.from(inputs);
}


function isRowFilled(inputs) {
  if (inputs.every((input) => input.value != 0)) {
    return true;
  }
  return false;
}

function calcRowCoverage(inputs) {
  const rowCoverage = parseFloat(
    (inputs[0].value * inputs[1].value).toFixed(3)
  );
  return rowCoverage;
}

function getSqmInputEl() {
  return document.getElementById("sqm-input");
}

function getRawSqmFromInput(el) {
  if (!el) return 0;
  const raw = el.dataset.rawSqm ?? el.value;
  const n = parseFloat(String(raw || "0").replace(",", "."));
  return isNaN(n) ? 0 : n;
}

function setSqmInputRaw(el, rawSqm) {
  if (!el) return;
  el.dataset.rawSqm = String(rawSqm);
}

function renderSqmInput(el) {
  if (!el) return;

  const rawSqm = getRawSqmFromInput(el);
  const displaySqm = includeBreakage ? applyBreakageToSqm(rawSqm) : rawSqm;

  // Keep display tidy (same style you use elsewhere)
  el.value = isFinite(displaySqm) ? displaySqm.toFixed(3) : "0.000";
}


function sqmToBoxInput(target) {
  if (!target.value) return;

  const rawSqm = parseFloat(String(target.value || "0").replace(",", "."));
  if (isNaN(rawSqm)) return;

  // store raw (without wastage)
  setSqmInputRaw(target, rawSqm);

  // compute boxes using effective sqm
  const effectiveSqm = applyBreakageToSqm(rawSqm);
  calcBoxNum(effectiveSqm);
}


function calcBoxNum(sqm) {

  const container = document.getElementById("tile-calculator");
  const qtyInput = container.querySelector(".js-qty__num");
  const totalPriceEl = document.querySelector(".sqm-total"); // see #2 below

  // compute box count
  const ratio = sqm / sqmPerBox;


  // If ratio is extremely close to a whole number (e.g. 5.9999999998 or 6.0000000002),
  // treat it as that whole number, otherwise ceil normally.
  const nearest = Math.round(ratio);
  const boxNum = (Math.abs(ratio - nearest) < 1e-6) ? nearest : Math.ceil(ratio);

  // prevent loop only around qty dispatch, not the whole function
  if (!isSyncing && qtyInput) {
    isSyncing = true;
    if (parseInt(qtyInput.value) !== boxNum) {
      qtyInput.value = boxNum;
      qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
    isSyncing = false;
  }

  // ⬇️ Always allow total update
  if (totalPriceEl) {
    const basePriceText = totalPriceEl.getAttribute("data-base-price") || totalPriceEl.innerText;
    const basePrice = parseFloat((basePriceText || '').replace(/[^\d.]/g, ""));
    if (!isNaN(basePrice)) {
      const totalPrice = (basePrice * boxNum).toFixed(2);
      totalPriceEl.innerText = formatMoney(totalPrice)/*`£${totalPrice}`*/;
    }
  }
}


function calcSQM(boxNum) {

  if (isSyncing) return; // prevent loop
  isSyncing = true;

  const container = document.getElementById("tile-calculator");
  const qtyInput = container?.querySelector(".js-qty__num");
  const sqmInput = document.getElementById("sqm-input");
  const totalPriceEl = document.querySelector(".sqm-total");

  // RAW sqm based on boxes (never includes breakage)
  const rawSqm = parseFloat(
    (boxNum == 0 ? sqmPerBox : boxNum * sqmPerBox).toFixed(3)
  );

  // store raw, render display based on includeBreakage
  if (sqmInput) {
    setSqmInputRaw(sqmInput, rawSqm);
    renderSqmInput(sqmInput);
  }

  // ✅ Update total price directly from boxNum (do NOT call calcBoxNum again)
  if (totalPriceEl) {
    const basePriceText = totalPriceEl.getAttribute("data-base-price") || totalPriceEl.innerText;
    const basePrice = parseFloat((basePriceText || '').replace(/[^\d.]/g, ""));
    if (!isNaN(basePrice)) {
      const totalPrice = (basePrice * boxNum).toFixed(2);
      totalPriceEl.innerText = formatMoney(Number(totalPrice));
    }
  }

  isSyncing = false;
}

function updateDisplay(target, value) {
  if ("value" in target) {
    if (target.value != value) {
      target.value = value;
    }
  } else {
    if (target.innerText != value) {
      target.innerText = value;
    }
  }
}

function bindRowInputListeners() {
  const rowInputs = document.querySelectorAll('.row-inputs .fsc-input-grid-item input:not([disabled])');
  rowInputs.forEach((input) => {
    input.removeEventListener("input", handleRowInput);
    input.addEventListener("input", handleRowInput);
  });
}


function handleRowInput() {
  calcTotalCoverage();
}


document.addEventListener("DOMContentLoaded", MyInits);
